// TempDash — Cookie Notice
// UK GDPR + PECR-compliant. Bump VERSION when amending.

// PRE-LAUNCH: platform not live yet (test data only) — held at VERSION
// '1.0' (first version published at go-live). Don't increment until prod
// is live; edit the 1.0 text in place.
//
// Edited in place 2026-07-17: the notice named dental.tempdash.app as a site we
// operate, and that host is retired with the V1 app. Surfaces are now
// tempdash.app + dashboard.tempdash.app. VERSION held at 1.0 per the convention
// above (nobody has agreed to a published 1.0 yet, so a bump would signal a
// change to users who never saw the original); EFFECTIVE_DATE refreshed.
export const VERSION        = '1.0'
export const EFFECTIVE_DATE = '17 July 2026'

const text = `# TempDash — Cookie Notice

**Version 1.0 — Effective Date: 17 July 2026**

This Cookie Notice explains how TempDash Ltd ("TempDash", "we", "us") uses cookies and similar device-storage technologies on our websites (tempdash.app and dashboard.tempdash.app). It should be read alongside our [Privacy Policy](/legal/privacy). TempDash is a trading name of TempDash Ltd, a company registered in England and Wales.

## 1. What these technologies are

"Cookies" are small text files a website stores on your device. We also use **local storage** — a related browser technology — for the same purposes. Under the Privacy and Electronic Communications Regulations ("PECR"), both are treated the same way: we only use them where they are strictly necessary, or where you have given your consent.

## 2. Our approach — consent first

We do **not** place any non-essential cookies or storage until you have agreed. When you first visit, a banner lets you **Accept Analytics**, **Reject Optional**, or choose per category under **Cookie settings**. Analytics stays off until you click **Accept Analytics** or switch it on yourself; nothing is pre-selected. Until you make a choice, only strictly necessary storage is used. You can change or withdraw your choice at any time using the **Cookie settings** link in the website footer.

## 3. What we use

### 3.1 Strictly necessary (always on — no consent required)

These are essential for the site to function and cannot be switched off.

- **Authentication & session** — keeps you signed in and secures your account.
- **Consent record** — remembers your cookie choice so we don't ask on every page.
- **Security** — protects against fraud and abuse.

### 3.2 Analytics (off by default — consent required)

First-party analytics that help us understand how the site is used so we can improve it.

- **Analytics session identifier** — a random, anonymous reference saved in your browser for up to 30 days. It is **not** linked to your identity. We use it to count page views and time-on-page on our own servers. No data is shared with third parties, and we do not use it for advertising.

We do **not** use advertising or third-party tracking cookies, and we do not sell your data.

## 4. Third-party services on certain pages

Some pages load tools from trusted providers to deliver a feature you've asked for. These are functional, not tracking, technologies:

- **Stripe** — loaded on payment pages for fraud prevention and to process payments.
- **Google Maps** — loaded on shift-location pages to display maps.

These providers may set their own cookies governed by their own policies. We only load them where the feature requires it.

## 5. Managing your choice

- **On TempDash:** use the **Cookie settings** link in the footer to review or withdraw consent at any time.
- **In your browser:** you can block or delete cookies and local storage via your browser settings. Blocking strictly necessary storage may stop parts of the site working.

## 6. Changes to this Notice

We may update this Notice as our use of these technologies changes. Where the change is material, we will re-request your consent.

## 7. Contact

**Email:** support@tempdash.app
**Post:** Data Protection, TempDash Ltd, 124 City Rd, London EC1V 2NX
**ICO:** https://ico.org.uk · 0303 123 1113
`

export default text
